import {PLATFORM} from 'aurelia-framework'
import requestFrame from 'request-frame'
import bowser from 'bowser'

let raf = requestFrame('request');
let caf = requestFrame('cancel');

if (bowser.msie) {
  raf = raf.bind(PLATFORM.global);
  caf = caf.bind(PLATFORM.global);
}

export default class Tween {

  static defaultQueue = 'defaultQueue';

  private __targetEl: Element & { __tweenData?: any };

  constructor(element: Element) {
    this.__targetEl = element;
  }

  /**
   * @param {string} [queue="defaultQueue"]
   * @param {Function} [step]
   * @param {Function} [complete]
   * @param {number} [duration=0]
   * @return {Tween}
   */
  run({
    duration = 0,
    step = PLATFORM.noop,
    complete = PLATFORM.noop,
    queue = Tween.defaultQueue
  }) {
    let startTime;

    if (!this.__targetEl.__tweenData) {
      this.__targetEl.__tweenData = {};
    }

    let data = this.__targetEl.__tweenData[queue];
    if (!data) {
      this.__targetEl.__tweenData[queue] = data = new Array(2);
    }

    // let count = 0;

    function callback(time) {
      // count++;
      let delta = time - startTime;
      if (delta < 0) {
        startTime = time;
        delta = 0;
      }

      if (delta < duration) {
        step(delta / duration, delta);
        data[0] = raf(callback);
      } else {
        step(1, delta);
        data[1] = false;
        complete();
        // console.log('fps:' + (1000 * count / delta));
        // console.log(`fps: ${1000 * count / delta}`);
      }

      // console.log(`from number: ${num}`);
    }

    startTime = PLATFORM.performance.now();
    data[0] = raf(callback);
    data[1] = true;

    return this;
  }

  /**
   * @param {string} [queue="defaultQueue"]
   * @return {Tween}
   */
  stop(queue = Tween.defaultQueue) {
    let tweenData = this.__targetEl.__tweenData;
    if (tweenData) {
      let data = tweenData[queue];
      if (data && data[1]) {
        caf(data[0]);
        data[1] = false;
      }
    }

    return this;
  }

  /**
   * @param {string} [queue="defaultQueue"]
   * @return {boolean}
   */
  isRunning(queue = Tween.defaultQueue) {
    let tweenData = this.__targetEl.__tweenData;
    return tweenData && tweenData[queue] && tweenData[queue][1];
  }

}
